@if (showClear) {
  <app-svg-icon
    [iconName]="large ? actionIcons.close : actionIcons.closeSm"
    class="dropdown-close-icon cursor"
    [isStaticSvg]="true"
    [matTooltip]="tooltipText"
    matTooltipPosition="above"
    (click)="onClear($event)"
    (keydown)="$event.stopPropagation()">
  </app-svg-icon>
}
